import component from "../section/component";

export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              style: {
                'display':'flex', 
                'gap':'20px', 
                'flex-wrap':'wrap'
              },
              components:[
                {
                  type:'image',
                  traits: [
                    {
                      type: 'text', 
                      name:'src',
                      label: 'link',
                      id:'src',
                    },
                    {
                      type: 'text', 
                      name:'alt',
                      id:'alt',
                    },
                    {
                      type:'id',
                      name:'id',
                      Label:'id',
                    },
                    {
                      type:'checkbox',
                      name:'loading',
                      id:'loading',
                      label: 'Lazy Load',
                      valueTrue: 'lazy',
                      valueFalse: ''
                    },
                  ],
                  style: {
                    'width': '49%',
                    'height': '300px', 
                    'object-fit': 'cover'
                  },
                },{
                  type:'image',
                  traits: [
                    {
                      type: 'text', 
                      name:'src',
                      label: 'link',
                      id:'src',
                    },
                    {
                      type: 'text', 
                      name:'alt',
                      id:'alt',
                    },
                    {
                      type:'id',
                      name:'id',
                      Label:'id',
                    },
                    {
                      type:'checkbox',
                      name:'loading',
                      id:'loading',
                      label: 'Lazy Load',
                      valueTrue: 'lazy',
                      valueFalse: ''
                    },
                  ],
                  style: {
                    'width': '49%',
                    'height': '300px', 
                    'object-fit': 'cover'
                  },
                },
                {
                  type:'image',
                  traits: [
                    {
                      type: 'text', 
                      name:'src',
                      label: 'link',
                      id:'src',
                    },
                    {
                      type: 'text', 
                      name:'alt',
                      id:'alt',
                    },
                    {
                      type:'id',
                      name:'id',
                      Label:'id',
                    },
                    {
                      type:'checkbox',
                      name:'loading',
                      id:'loading',
                      label: 'Lazy Load',
                      valueTrue: 'lazy',
                      valueFalse: ''
                    },
                  ],
                  style: {
                    'width': '49%',
                    'height': '300px', 
                    'object-fit': 'cover'
                  },
                },
                {
                  type:'image',
                  traits: [
                    {
                      type: 'text', 
                      name:'src',
                      label: 'link',
                      id:'src',
                    },
                    {
                      type: 'text', 
                      name:'alt',
                      id:'alt',
                    },
                    {
                      type:'id',
                      name:'id',
                      Label:'id',
                    },
                    {
                      type:'checkbox',
                      name:'loading',
                      id:'loading',
                      label: 'Lazy Load',
                      valueTrue: 'lazy',
                      valueFalse: ''
                    },
                  ],
                  style: {
                    'width': '49%',
                    'height': '300px', 
                    'object-fit': 'cover'
                  },
                },
                
              ],
             
              
            },
            
          },
          view: {},
};
  return component; 
};